import './signing-area.scss'

import { defineComponent } from 'vue';
import { faCheck, faEraser } from "@fortawesome/free-solid-svg-icons";

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { FreeDrawingTool } from '@skinsoft/entity-ui/src/condition-report/drawing-toolbox'
import { SIGNATURE_UPDATED } from '../../../../busTopics';

export interface SignatureDrawing {
    canvas: { width: number, height: number },
    signature: any[]
}

const DEFAULT_SIGNATURE_CANVAS_WIDTH = 700;
const DEFAULT_SIGNATURE_CANVAS_HEIGHT = 300;
const STROKE_WIDTH = 5;
const STROKE_COLOR = 'black';

export const SigningArea = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        signature: {
            type: String,
            default: '',
        },
        showSaveButton: {
            type: Boolean,
            default: false,
        },
        showClearButton: {
            type: Boolean,
            default: true,
        }
    },
    template: require('./signing-area.html'),
    data() {
        return {
            shapes: {
                canvas: {
                    height: DEFAULT_SIGNATURE_CANVAS_HEIGHT,
                    width: DEFAULT_SIGNATURE_CANVAS_WIDTH
                }, signature: []
            } as SignatureDrawing,

            // Icons
            eraseIcon: faEraser,
            checkIcon: faCheck,

            // Drawing data
            configKonva: {
                height: DEFAULT_SIGNATURE_CANVAS_HEIGHT,
                preventDefault: true,
                width: DEFAULT_SIGNATURE_CANVAS_WIDTH,
            },
            startClick: undefined as any,
            currentShape: undefined as any,
            freeDrawingTool: new FreeDrawingTool(STROKE_WIDTH, STROKE_COLOR),
            isDrawing: false,
            shapeIndex: 0,
            signatureOk: false,
        }
    },
    mounted() {
        const stage = (this.$refs.stage as any).getStage();
        const stageWidth = stage.container().clientWidth;
        stage.width(stageWidth);
        this.shapes.canvas.width = stageWidth

        // Bound imperatively, not via template @mousedown etc.: <v-stage> reads listeners off its
        // own `attrs`, which @vue/compat MODE 2 excludes from a component's $attrs.
        stage.on('mousedown touchstart', this.onTouchStart)
        stage.on('mouseup touchend', this.onTouchEnd)
        stage.on('mousemove touchmove', this.onTouchMove)
    },
    beforeUnmount() {
        (this.$refs.stage as any)?.getStage()?.off('mousedown touchstart mouseup touchend mousemove touchmove')
    },
    methods: {
        saveSignature() {
            this.$emit(SIGNATURE_UPDATED, JSON.stringify(this.shapes))
        },
        clearSignature() {
            if (!this.isDrawing) {
                this.shapes = this.blankSignatureDrawing()
                this.saveSignature()
            }
        },
        // Drawing methods
        onTouchStart(event) {
            event.evt.preventDefault()
            event.evt.stopPropagation()
            if (event.currentTarget._pointerPositions) {
                this.startClick = {}
                this.startClick.x = event.currentTarget._changedPointerPositions[0].x;
                this.startClick.y = event.currentTarget._changedPointerPositions[0].y;

                this.currentShape = this.freeDrawingTool.addShape(this.startClick.x, this.startClick.y, this.shapeIndex)
                this.shapes.signature.push(this.currentShape)
                this.shapeIndex++;
                this.isDrawing = true;
            } else {
                this.startClick = undefined
            }
        },
        onTouchMove(event) {
            event.evt.preventDefault()
            event.evt.stopPropagation()
            if (this.isDrawing && event.currentTarget._changedPointerPositions) {

                const currentX = event.currentTarget._changedPointerPositions[0].x;
                const currentY = event.currentTarget._changedPointerPositions[0].y;

                this.freeDrawingTool.onTouchMove(this.currentShape, currentX, currentY, this.startClick.x, this.startClick.y);
            }
        },
        onTouchEnd(event) {
            event.evt.preventDefault()
            event.evt.stopPropagation()
            if (this.startClick && event.currentTarget._changedPointerPositions) {

                const endX = event.currentTarget._changedPointerPositions[0].x;
                const endY = event.currentTarget._changedPointerPositions[0].y;
                this.freeDrawingTool.onTouchEnd(this.currentShape, endX, endY, this.startClick.x, this.startClick.y)
                this.currentShape = null;
                this.saveSignature()
            }
            this.isDrawing = false;
        },
        blankSignatureDrawing(): SignatureDrawing {
            return {
                canvas: {
                    height: DEFAULT_SIGNATURE_CANVAS_HEIGHT,
                    width: DEFAULT_SIGNATURE_CANVAS_WIDTH,
                },
                signature: []
            } as SignatureDrawing
        },
    },
    watch: {
        signature: {
            handler(signature) {
                this.shapes = signature ? JSON.parse(signature) : this.blankSignatureDrawing()
                this.shapeIndex = this.shapes.signature.length
                //this.$forceUpdate()
            },
            immediate: true,
        },
        shapes: {
            handler() {
                this.signatureOk = this.signature.length > 0
            },
            immediate: true,
            deep: true,
        },
    },
})
